import { Component, OnInit, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { InactivityDialogComponent } from './inactivity-dialog.component';

@Component({
  selector: 'app-inactivity',
  templateUrl: './inactivity.component.html',
  styleUrls: ['./inactivity.component.css']
})
export class InactivityComponent implements OnInit {

  inactivityModalRef: MatDialogRef<InactivityDialogComponent>;

  constructor(private dialog: MatDialog, private router: Router, private zone: NgZone) { }

  ngOnInit() {
    this.inactivityModalRef = this.dialog.open(InactivityDialogComponent, { width: '600px', height: '600px', disableClose: true, closeOnNavigation: false });
    this.inactivityModalRef.afterClosed().subscribe(result => {
      const pathIndex = top.location.href.indexOf(top.location.pathname);
      const rootPath = top.location.href.substring(0, pathIndex);

      top.location.href = rootPath;

    });
   
  }

}
